define([
    'jQuery',
    'underscore',
    'library/fcse-widget/widget',
    'library/fcse-compatibility/object',
    'library/fcse-dropdown/dropdown',
    'library/fcse-ratingwidget/ratingWidget',
    'clientComponents/globaltype/globalTypeWidget',
    'clientComponents/search/searchWidget',
    'clientComponents/priceslider/priceSliderRangeWidget',
    'clientComponents/ratingslider/ratingSliderRangeWidget'
  ],
  function($, _, Widget, Object, Dropdown, RatingWidget, GlobalTypeWidget, SearchWidget, PriceSliderRangeWidget, RatingSliderRangeWidget) {

    var ExtendedSearchWidget = function (element, options) {
      Widget.apply(this, arguments);

      //Set options
      var defaultOptions = {

      };

      this.addOptions(defaultOptions, options);
      this._init();
    };

    ExtendedSearchWidget.prototype = $.extend(Object.create(Widget.prototype), {
      _init: function() {
        var options = this.getOptions();
        /*var hotelSearch = new SearchWidget('#searchmask-search-widget',
          {
            rootScope: options.scopes.rootScope,
            useHeader: true,
            useRootScopeParams: ['groupNames', 'category', 'hotelAttributes']
          },
          options.scopes.localScope,
          true);*/

        // this._excludedWidgetKeys = ['globalTypes', 'minPrice', 'maxPrice', 'minRating', 'maxRating'];
        this._excludedWidgetKeys = ['globalTypes', 'minPrice', 'maxPrice'];

        var priceRangeWidget = new PriceSliderRangeWidget('#widget-price-range');
        // var ratingRangeWidget = new RatingSliderRangeWidget('#widget-rating-range');

        this._widgets = {
          /*'hotelName': null,*/
          'room': new Dropdown('#widget-room'),
          'board' : new Dropdown('#widget-board'),
          'rating': new RatingWidget('#widget-rating'),
          'minPrice' : priceRangeWidget,
          'maxPrice' : priceRangeWidget,
          /*'minRating' : ratingRangeWidget,
          'maxRating' : ratingRangeWidget,*/
          'category' : new RatingWidget('#widget-category'),
          'globalTypes': new GlobalTypeWidget('[data-fcse-role="globaltypewidget"]')
        };

        this.setValue(this.getValueFromUi());

      },

      getValueFromUi: function() {
        var result = {};

        _.each(this._widgets, function(value, key) {
          if (!value) {
            return;
          }
          if (key === 'minPrice' || key == 'maxPrice') {
            result = $.extend(result, key === 'minPrice' ?
              {minPrice: value.getValue()[0]} :
              {maxPrice: value.getValue()[1]}
            );
          } else if (key === 'minRating' || key == 'maxRating') {
            result = $.extend(result, key === 'minRating' ?
              {minRating: value.getValue()[0]} :
              {maxRating: value.getValue()[1]}
            );
          } else if (key === 'globalTypes') {
            result = $.extend(result, value.getValue());
          } else {
            result[key] = value.getValue();
          }
        });
        return result;

      },

      setValueToUi: function() {
        var self = this;
        var value = this.getValue();
        var valueKeys = _.keys(value);
        var widgetKeys = _.keys(this._widgets);
        delete widgetKeys['globalTypes'];

        var gtValue = {};
        var gtKeys = _.difference(valueKeys, widgetKeys);

        if (gtKeys.length) {
          _.each(gtKeys, function(key) {
            gtValue[key] = value[key];
          });
        }
        _.each(value, function(value, key) {
          if (!self._widgets[key]) {
            return;
          }
          if (_.indexOf(self._excludedWidgetKeys, key) === -1) {
            self._widgets[key].setValue(value);
          }
        });
        this._widgets.globalTypes.setValue(gtValue);
        this._widgets.minPrice.setValue([value.minPrice, value.maxPrice]);
        // this._widgets.minRating.setValue([value.minRating, value.maxRating]);
      }
    });

    return ExtendedSearchWidget;
  }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/extendedsearch/extendedSearchWidget.js